import { render, staticRenderFns } from "./add-new-dialog.vue?vue&type=template&id=497c4e44&"
import script from "./add-new-dialog.vue?vue&type=script&lang=js&"
export * from "./add-new-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports